import humps from 'humps'

import { porticoApi } from 'store/porticoApi'
import { TCreatePermission, TPermission, TUpdatePermission } from 'types/permissions'

const permissions = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    createPermission: builder.mutation<TPermission[], TCreatePermission[]>({
      query: (body) => ({
        url: 'operator/permissions',
        method: 'POST',
        body: humps.decamelizeKeys({ permissions: body }),
      }),
      invalidatesTags: ['Roles'],
    }),
    updatePermission: builder.mutation<TPermission[], TUpdatePermission[]>({
      query: (body) => ({
        url: 'operator/permissions',
        method: 'PUT',
        body: humps.decamelizeKeys({ permissions: body }),
      }),
      invalidatesTags: ['Roles'],
    }),
    deletePermission: builder.mutation<TPermission[], string>({
      query: (uuid) => ({
        url: `operator/permissions/${uuid}`,
        method: 'DELETE',
        body: { uuid },
      }),
      invalidatesTags: ['Roles'],
    }),
  }),
})

export const {
  useCreatePermissionMutation,
  useUpdatePermissionMutation,
  useDeletePermissionMutation,
} = permissions
